import { attr, Model, ModelType } from 'redux-orm';
import {
  GET_INTEGRATION_SUBSCRIPTIONS_SUCCESS,
  REMOVE_INTEGRATION_SUBSCRIPTION_SUCCESS,
} from 'actions';
import { AuthStatus } from 'enums/authStatus';

export interface IIntegration {
  /**
   * The id attached to the authorization code request
   */
  id: string;
  /**
   * The integration type
   */
  type: 'o365';
  /**
   * The id of the user within the BeeCastle instance
   */
  userId: string;
  /**
   * The accountId within the service being integrated
   */
  accountId: string;
  /**
   * The account name within the service being integrated
   */
  accountName: string;
  /**
   * Data object relating to the current status of the integration
   */
  data: {
    auth: Record<string, unknown>;
    services: {
      email: {
        status: AuthStatus;
        error?: string;
      };
      calendar: {
        status: AuthStatus;
        error?: string;
      };
    };
  };
}

class Integration extends Model<typeof Integration, IIntegration> {
  static reducer(action: any, model: ModelType<Integration>) {
    // eslint-disable-next-line default-case
    switch (action.type) {
      case GET_INTEGRATION_SUBSCRIPTIONS_SUCCESS:
        action.data.map((d: IIntegration) => model.upsert(d));
        break;
      case REMOVE_INTEGRATION_SUBSCRIPTION_SUCCESS:
        model.withId(action.data.accountName)?.delete();
        break;
    }

    return undefined;
  }

  toViewModel() {
    return {
      ...this.ref,
    };
  }
}

Integration.modelName = 'Integration';

Integration.fields = {
  id: attr(),
  type: attr(),
  userId: attr(),
  accountId: attr(),
  accountName: attr(),
  data: attr(),
};

Integration.options = {
  // accountName is used instead of id due to if you re-add the same o365 account we re-create with a new id (accountName stays the same)
  idAttribute: 'accountName',
};

export type IntegrationViewModel = ReturnType<Integration['toViewModel']>;

export default Integration;
